import { inject } from "inversify-props";
import { ConfigService } from "./config/ConfigService";
import { HttpService } from "./HttpService";

export class CategoryDataService {
  @inject("HttpService") httpService: HttpService;
  @inject("ConfigService") configService: ConfigService;

  async getCategoryList() {
    const categoryEndpoint = `${this.configService.getConfig(
      "cr3Url"
    )}/api/v1/categories`;
    return await this.httpService.get<any[]>(categoryEndpoint);
  }
}
